export const BrandTemplates = {
  BRAND_DATA: 'BRAND_COVER',
  BRAND_STORIES: 'STORIES',
  PRODUCT_HORIZONTAL: 'PRODUCTS_WITH_HORIZONTAL_LAYOUT',
  BANNER_SLIDER: 'INSERT_BANNER-CAROUSEL_DEFAULT',
  PRODUCT_CATEGORIES: 'PRODUCT_CATEGORIES',
  POST: 'NEW_POSTS',
  SINGLE_VIDEO: 'INSERT_BRAND-CAROUSEL_MEDIA-ONLY',
  PRODUCT_LISTING: 'PRODUCTS_WITH_CATALOG_LAYOUT',
  RECENT_POSTS: 'RECENT_POSTS'
};

export const BrandPagePostTypes = {
  MEDIA_ONLY: 'MEDIA_ONLY',
  MEDIA_WITH_RESOURCES: 'MEDIA_WITH_RESOURCES',
  RESOURCE_ONLY: 'RESOURCE_ONLY'
};
